module.exports = __webpack_public_path__ + "img/request-new-password.167458e8.png";